<template>
  <v-combobox
    ref="combobox"
    :class="{ required: field.required }"
    :model-value="field.value"
    :rules="validationRules"
    :items="field.dropDownValues"
    v-bind="{ ...$props, ...$attrs }"
    @update:model-value="value => $emit('input', value || '')"
    density="compact"
    clearable
    open-on-clear>
    <template #label>
      {{ t('customFields.forms.customFieldsForm.placeholders.chooseOrTypeAValue') }}
    </template>
  </v-combobox>
</template>

<script>
import customFieldTypeMixin from '@/modules/custom_fields/mixins/customFieldTypeMixin';
import { t } from '@nova/core';

export default {
  name: 'custom-field-combobox',
  mixins: [customFieldTypeMixin],
  methods: { t }
};
</script>
